module.exports = __webpack_public_path__ + "img/Footer.4ab08e20.png";